import React from "react";
import BoxLoader from "../../../../../../components/general/boxLoader";
import EmptyBox from "../../../../../../components/general/emptyBox";
import PatientCigarettesCardsBoxItem from "./patientCigarettesCardsBox_Item";

type PatientFamilyHistoryCardsBoxProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean
}

const PatientCigarettesCardsBox = ({
  dataList,
  dataListTitles,
  isRequesting
}: PatientFamilyHistoryCardsBoxProps) => {
  const _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
    return <PatientCigarettesCardsBoxItem item={item} dataListTitles={dataListTitles} key={i}/>
  })
  return (
    <div>
      {isRequesting ? <BoxLoader/> : _dataList ? _dataList : <EmptyBox content={''} className={''} children={''}/>}
    </div>
  )
}

export default PatientCigarettesCardsBox;